(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('AgendaLabel', [AgendaLabelFactoryFn]);

    // agenda label model
    function AgendaLabelFactoryFn() {

        var AgendaLabel = function () {

            // default values
            this.addAddressToReminder = true;
            this.autoHour = false;
            this.dayItselfTimeLimit = null;
            this.fK_Agenda = null;
            this.fK_Color = null;
            this.firstFreeAppointmentDelay = null;
            this.hideTime = false;
            this.highlightNewPatient = true;
            this.hoursBeforeSMSReminderIsSent = 0;
            this.hoursBeforeEmailReminderIsSent = 0;
            this.isReadOnly = false;
            this.reverseAutoHour = false;
            this.sendConfirmationSMSToClient = false;
            this.sendConfirmationSMSToPatient = false;
            this.sendConfirmationMailToPatient = true;
            this.showInFirstFreeAppointments = true;
            this.isNoApppointmentPossibleLabel = false;
            this.deleted = false;
            //translation list of captions
            this.translations = [];
            //list of role-restrictions
            this.restrictedRoles = [];

            // vm 
            this.vmId = null; // random id for tracking -> so DOM is removed if needed


            // extend object
            function extend(label) {
                var self = this;
                angular.extend(self, label);
                // vm id 
                self.vmId = Math.random();
            } // extend

            // prepare for backend save
            function prepareForSave(restrictedRoles) {
                var self = this;

                self.fK_ApplicableToAgendaLabel = self.applicableToAgendaLabel ? self.applicableToAgendaLabel.id : null;
                self.fk_ExternalLocation = self.externalLocation 
                    ? self.externalLocation.id
                    : null;

                // prepare translation list
                var i = 0;
                var len = self.translations.length;
                for (i = 0; i < len; i++) {
                    self.translations[i].prepareForSave();
                    // set required foreign keys
                    self.translations[i].fK_AgendaLabel = self.id;
                }
                // add restricted roles
                var updateRoles = []; // clear
                restrictedRoles.forEach(function (role) {
                    var r = angular.copy(role);
                    delete r.role;
                    delete r.agendaLabel;
                    updateRoles.push(r);
                });
                self.restrictedRoles = updateRoles;

                delete self.applicableToAgendaLabel;
                delete self.externalLocation;
                delete self.visibleForRole;
                delete self.color;
                delete self.vmId;
            } //prepare



            //public
            this.extend = extend;
            this.prepareForSave = prepareForSave;

        };

        return AgendaLabel;
    }
})();